/**
 * The mobile number for a payment (hooks/usePayerPhone), shown once the
 * server has asked for it.
 */
export function PayerPhoneField({ payer, className = "" }) {
  if (!payer.asked) return null;
  return (
    <div className={`space-y-2 ${className}`}>
      <p
        role="note"
        className="p-3 rounded-lg bg-slate-50 border border-slate-200 text-xs font-medium text-slate-700"
      >
        Cashfree, the payment provider, needs a mobile number for this payment.
        It is not saved to your account.
      </p>
      <label className="block">
        <span className="field-label block mb-1.5 text-xs font-bold uppercase tracking-[.05em] text-[var(--color-text)]">
          Mobile number
        </span>
        <input
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          maxLength={14}
          value={payer.phone}
          onChange={(event) => payer.setPhone(event.target.value)}
          aria-invalid={Boolean(payer.error)}
          className={`field-input block w-full rounded-xl border ${payer.error ? "border-red-500" : "border-[#dce5e1]"} bg-white px-3.5 py-3 text-sm text-[var(--color-text)] outline-none transition focus:border-[var(--color-primary)] focus:ring-4 focus:ring-[rgba(0,25,82,0.12)]`}
        />
      </label>
      {payer.error ? (
        <p className="text-xs text-red-600">{payer.error}</p>
      ) : null}
    </div>
  );
}
